import { createPanelController } from '../shared/ui-panel-base.js';
import { getNicks, setNicks } from '../state-manager.js';
import { loadClientNicks, updatelientNicks } from '../requests/clients.js'; // Assuming this is where you fetch the food data
import { closePanel } from '../shared/ui-panel-controller.js';

let localNicks = []; // Each item: { id: int | null, name: string, locked: boolean }

export const editNickPanel = createPanelController('settings-nick-edit', {
  onOpen: () => {
    console.debug('[NickEditPanel] Opening nick edit panel');
    // hydrate list, reset form, etc.
    localNicks = structuredClone(getNicks()); // deep clone to detach from state
    renderNickList();
  },
  onClose: () => {
    console.debug('[NickEditPanel] Closing nick edit panel');
    // clean up state if needed
  },
});

function renderNickList() {
  const ul = document.getElementById('settings-nick-edit-list');
  ul.innerHTML = '';

  localNicks.forEach(nick => {
    // if (nick.is_owner) {
    //   return; // Skip owner nick
    // }

    const li = document.createElement('li');
    li.className = 'list-item';

    if (!nick.is_owner) {
      li.innerHTML = `
        <span class="label">${nick.nick}</span>
        <button class="lock-toggle">${nick.active ? '✅' : '❎'}</button>
      `;
      const lockToggle = li.querySelector('.lock-toggle');
      lockToggle.addEventListener('click', () => {
        nick.active = !nick.active;
        lockToggle.textContent = nick.active ? '✅' : '❎';
        // renderFoodList(); // Re-render for updated icon
      });
    } else {
      li.innerHTML = `
        <span class="label">${nick.nick} (owner)</span>
        `;
    }
    ul.appendChild(li);
  });
}

document.getElementById('settings-update-nicks-btn').addEventListener('click', async () => {
  const payload = localNicks.map(p => ({
    id: p.id,
    nick: p.nick.trim(),
    active: p.active ? 1 : 0,
  }));

  try {
    await updatelientNicks(payload);
    const refreshed = await loadClientNicks();
    setNicks(refreshed);
    editNickPanel.close();
  } catch (err) {
    console.error('Nick update failed:', err);
    alert('Unable to update nicknames.');
  }
});

document.querySelector('#settings-nick-edit-sheet .back-btn')?.addEventListener('click', () => {
  console.log('[NickEditPanel] Back to settings from nick edit panel');
  closePanel('settings-nick-edit'); // Will automatically restore previous panel (e.g. settings)
});  
